export const experience = [
    {
      role: "Teaching Assistant",
      company: "Brown Computer Science Department",
      start: "May 2022",
      end: "Present",
      description:
        "Assisted students in CS15: Object-Oriented Programming, CS200: Data Structures and Algorithms, and now in CS32: Software Engineering. I have helped redesign the course structure, create and playtest labs and assignments, act in the course skits, and create a welcoming community around the course. I support students with assignments through weekly office hours and 2-hour gear-ups with ~20 students to help reinforce concepts and kick-start course projects.",
      image: "brown.jpg",
    },
    {
      role: "Software Engineer Intern",
      company: "PlayStation",
      start: "May 2023",
      end: "Aug 2023",
      description:
        "Worked in a scrum of 6 interns to prototype a new feature for the PS5 software using the MERN stack, with the backend deployed on an AWS T1 instance. Given a task from a requestor, the team and I took a problem-centric approach by first laying out the primary problem and user needs underlying the said task, agreeing on the specifications with the requestor based on the needs, and moving into implementation.",
      image: "playstation.jpg",
    },
    {
      role: "Software Engineer Intern",
      company: "Nikkei",
      start: "Aug 2022",
      end: "Aug 2022",
      description:
        "At this hackathon-style short-term internship, I developed a web application that maps news articles to emojis by conducting sentiment analysis on the body texts. I implemented article-filtering via search words and emojis along with a user-friendly interface. I employed Vue.js, JavaScript, HTML, and CSS for the frontend; Python and Node.js for the backend.",
      image: "nikkei.jpg",
    },
    {
      role: "Software Engineer and UI Intern",
      company: "ZOAN",
      start: "Jun 2022",
      end: "Aug 2022",
      description:
        "I prototyped a user-friendly platform for doctors to easily render DICOM data in 3D, use it to better explain conditions to their patients, and understand the realistic circumstances of their surgeries beforehand. The prototype takes in DICOM data input from users to be rendered and provides a user-friendly virtual endoscopy module for doctors to simulate their vision during nasal surgery. I employed MeVisLab, MDL(MeVisLab Definition Language) scripting, Python, and visual programming.",
      image: "zoan.jpg",
    },
    {
      role: "Research Assistant",
      company: "Nelson Center for Entrepreneurship",
      start: "Feb 2022",
      end: "May 2022",
      description:
        "Working with the Nelson Center for Entrepreneurship Academic Program Manager, I researched the entrepreneurial landscape of Japan, its intersection with Japanese culture, and its differences from that of the US. Additionally, I identified and performed outreach to people and organizations working in the entrepreneurial ecosystem in Japan to develop a portfolio of contacts for a series of virtual programs (Japan Synapse) to be presented to the Brown community.",
      image: "brown.jpg",
    },
];